/**
 * EM LevelTree对象通用ListView mixin
 *   先混入emCommonListMixin
 *   再提供若干levelTree通用的方法
 *
 * Author YuJiaBei
 * Date 2020-07-14 16:14:36
 */

import EmZTree from "@/components/em/EmZTree";
import commonViewsUtil from "@/utils/commonViewsUtil";
import levelTreeUtil from "@/utils/levelTreeUtil";
import emCommonListMixin from "@/mixin/em/common/list";

export default {
    mixins: [emCommonListMixin],
    components:{EmZTree},
    computed: {
        $_emLevelTreeListMixin_menuTreeNodes:{
            get() {
                return this.$store.state[this.modelName].menuTreeNodes
            },
            set(value){
                this.$store.commit(this.modelName+"/setLevelTreeNodes", value, { root: true });
            }
        },
        $_emLevelTreeListMixin_handleClicking:{
            get(){
                return this.$store.state[this.modelName].handleClicking
            },
            set(value){
                this.$store.commit(this.modelName+"/setHandleClicking", value, { root: true });
            }
        },
        $_emLevelTreeListMixin_menuTreeSelectedId:{
            get(){
                return this.$store.state[this.modelName].filterHolder.parentIdFilter
            }
        }
    },
    methods: {
        $_emLevelTreeListMixin_gotoChild(entity) {
            commonViewsUtil.gotoHolderList(this, this.modelName, {
                parentIdFilter: entity.id,parentNameFilter:entity.name
            }, {parentId: entity.id,parentName:entity.name})
        },
        //清除gotoChild的filterHolder和entityHolder，然后重新执行查询
        $_emLevelTreeListMixin_clearHolderFromChild() {
            commonViewsUtil.gotoHolderList(this, this.modelName, {
                parentIdFilter: ""
            }, {parentId: ""})
        },
        $_emLevelTreeListMixin_gotoGrandParentLevel(entity) {
            let grandParentId = levelTreeUtil.getGrandParentId(entity.level)
            let parentLevel = levelTreeUtil.getGrandParentLevel(entity.level)
            commonViewsUtil.gotoHolderList(this, this.modelName, {
                parentIdFilter: grandParentId,
                levelFilter: parentLevel
            }, {parentId: grandParentId})
        },
        $_emLevelTreeListMixin_menuTreeOnClick(event, treeId, treeNode, clickFlag){
            //防止单击导致自己重新刷新
            this.$_emLevelTreeListMixin_handleClicking = true
            this.$_emLevelTreeListMixin_gotoChild(treeNode)
        },
        $_emLevelTreeListMixin_retrieveLevelTreeNodes(){
            this.$store.dispatch(this.modelName+"/retrieveLevelTreeNodes", {},{ root: true });
        },
        $_emLevelTreeListMixin_getGrandParentId(entity) {
            return levelTreeUtil.getGrandParentId(entity.level)
        }
    },
    //mounted() {
            //this.$_emLevelTreeListMixin_retrieveLevelTreeNodes();
    //}
};